import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '../Header';
import { ToastContainer, toast } from 'react-toastify';
import WrongNetwork from 'components/common/WrongNetwork';
import ToastMessage from 'components/common/ToastMessage';
import alertTriangle from 'assets/images/alert_triangle.svg';

const Layout = ({ children }) => {
    const {
        web3Connected,
        netWorkSupported,
        ChainListLoader,
    } = useSelector((state) => state.Trade);
    const isMobile = window.innerWidth <= 700;

    useEffect(() => {
        if (web3Connected && !netWorkSupported && !ChainListLoader) {
            toast(
                <ToastMessage
                    statusImage={alertTriangle}
                    toastMessage={
                        'Please connect to a supported network in the dropdown menu or in wallet.'
                    }
                    shortMessage={'Wrong network'}
                    toastTextClass={'toastText'}
                />,
                {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [web3Connected, netWorkSupported, ChainListLoader]);

    useEffect(() => {
        if (web3Connected) {
            const timer = setTimeout(() => {
                toast.success(
                    <ToastMessage
                        shortMessage={'Wallet Connected'}
                        toastTextClass={'toastText'}
                    />,
                    {
                        position: 'top-right',
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        closeButton: false,
                    }
                );
            }, 1000);

            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [web3Connected]);

    return (
        <>
            <div
                className={`${!netWorkSupported ? '' : 'ToastifyWidth'}`}
            >
                <ToastContainer
                    toastStyle={{
                        backgroundColor: 'var(--system-color-300)',
                        borderRadius: '10px',
                        border: '1px solid var(--system-color-400)',
                        right: isMobile ? '0' : 'auto',
                        left: isMobile ? '0' : 'auto',
                    }}
                    position="top-right"
                    autoClose
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    closeButton={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    bodyClassName="toastBody"
                />
            </div>
            <Header />
            {(web3Connected && !netWorkSupported && !ChainListLoader) && (
                <WrongNetwork />
            )}
            {children}
        </>
    );
};

export default Layout;
